import type { NestedI18nObject } from '../../utils';

const admin: NestedI18nObject = {
  // 管理员页面
  subPage: {
    title: ' 这个页面只有 admin 权限才能查看',
    alertMessage: 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  },
};

export default admin;
